// client/src/components/TaskGroup.js
import React from 'react';

export default function TaskGroup({
  group,
  order,
  currentOrderTaskState,
  handleTaskChange,
  loading,
  TaskInputRow
}) {
  const titleClass = 'fw-bold text-center text-md-start';
  const taskWrapperClass =
    'd-flex flex-column align-items-center align-items-md-start gap-2';

  const isSeamstressGroup = group.group === 'Seamstress Tasks';

  return (
    <div className="mb-3">
      <h6 className={titleClass}>{group.group}</h6>

      <div className={taskWrapperClass}>
        {/* Non-Seamstress tasks */}
        {!isSeamstressGroup &&
          group.tasks?.map(task => (
            <TaskInputRow
              key={task.id}
              order={order}
              task={task}
              currentOrderTaskState={currentOrderTaskState}
              handleTaskChange={handleTaskChange}
              loading={loading}
              alignDesktop="start"
            />
          ))}

        {/* Seamstress subtasks */}
        {isSeamstressGroup &&
          group.subtasks?.map(sub => (
            <div key={sub.subgroup} className="mb-2 w-100">
              <strong className={`d-block mt-2 mb-1 ${titleClass}`}>
                {sub.subgroup}:
              </strong>

              <div className="d-flex flex-column align-items-center align-items-md-start mt-1">
                {sub.tasks.map(task => (
                  <TaskInputRow
                    key={task.id}
                    order={order}
                    task={task}
                    currentOrderTaskState={currentOrderTaskState}
                    handleTaskChange={handleTaskChange}
                    loading={loading}
                    alignDesktop="start"
                  />
                ))}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
